import { useEffect, useState } from 'react'

import { useToasts } from '@/hooks/useToasts'

import { useUpdateAiOperatorResponseRulesMutation } from '@/graphql/generated/hooks'

export const useUpdateIncidentRules = ({
  isDryRunInitial,
  isDryRunInitialLoading,
  ruleId,
}: {
  isDryRunInitial: boolean
  isDryRunInitialLoading: boolean
  ruleId: string
}) => {
  const { showError, showSuccess } = useToasts()
  const [isDryRun, setIsDryRun] = useState(null)

  useEffect(() => {
    setIsDryRun(isDryRunInitial)
  }, [isDryRunInitial])

  const [updateAiOperatorRuleMutation, { loading: isUpdateLoading }] =
    useUpdateAiOperatorResponseRulesMutation()

  const onDryRunToggle = async () => {
    try {
      await updateAiOperatorRuleMutation({
        variables: {
          input: {
            isDryRun: !isDryRun,
            ruleId,
          },
        },
      })
      setIsDryRun((prevIsDryRun) => !prevIsDryRun)
      showSuccess('Dry run successfully updated for this rule')
    } catch (e) {
      showError('Failed to update rule dry run')
    }
  }

  return {
    isDryRun,
    isLoading: isUpdateLoading || isDryRunInitialLoading,
    onDryRunToggle,
  }
}
